/*global page */
var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  const NAME = 'process';
  const PROCESSING = "processing_canvas";
  const NOT_AWESOME = "not_awesome";
  const YES_AWESOME = "yes_awesome";
  var pageManager = fc.pageManager;

  var currentPage = pageManager.Page.create(NAME, '/' + NAME, '#' + NAME);

  currentPage.html = `<h1><img src="/assets/app/logo.svg" id="logo"></h1><div class="content"><p class="upper hidden">Do you still look awesome?</p><div class="middle"><div class="c_wrap"><canvas id="${PROCESSING}"></canvas></div></div></div><footer class="hidden"><a id="${NOT_AWESOME}" href="/create" class="button"><img src="/assets/app/xbutton.svg"></a><span></span><a id="${YES_AWESOME}" href="/backgrounds" class="button"><img src="/assets/app/okbutton.svg"></a></footer>`;

  currentPage.eventHandlers = [
    {
      event: 'click',
      target: '#' + NOT_AWESOME,
      handler: function () {
        fc.ga('/not_awesome');
      }
    },
    {
      event: 'click',
      target: '#' + YES_AWESOME,
      handler: function () {
        fc.ga('/yes_awesome');
      }
    }
  ];

  pageManager.add(currentPage);
  fc.utils.DEBUG_CANVAS = PROCESSING;
  currentPage.run = function () {
    var points,
      facePoints,
      selfie = document.createElement('canvas'),
      dumpCtx,
      cx, cy;

    selfie.width = fc.appState.selfie.width;
    selfie.height = fc.appState.selfie.height;
    selfie.getContext('2d').putImageData(fc.appState.selfie,0,0);
    dumpCtx = fc.utils.dump(selfie);

    fc.appState.foreground = null;

    console.time('facetrack');
    fc.faceDetect(selfie).then(function (face) {
      console.timeEnd('facetrack');

      dumpCtx.rect(face[0], face[1], face[2], face[3]);
      console.log(face);
      return fc.faceFeatureDetect(selfie, face);
    }).then(function (faceFeaturePoints) {
      facePoints = faceFeaturePoints;
      if (facePoints.length > 40) {
        // real face detected
        points = fc.findClickPoints(selfie.width, selfie.height,
                                    facePoints[1], facePoints[13], facePoints[7]);
        cx = facePoints[37][0];
        cy = facePoints[37][1];
      } else {
        // fallback
        cx = selfie.width/2|0;
        cy = selfie.height/2|0;

        points = faceFeaturePoints;
      }
      return fc.utils.pleaseFilter('bgfill', selfie, {
        maxDiff: 40,
        adaptive: 5,
        points: points
      });
    }).then(function (imgData) {
      var referenceColors = fc.colorUtils.getColors(imgData, points);
      var faceColors = fc.colorUtils.getColors(imgData, facePoints.slice(0, 70));
      var avgFaceColor = fc.colorUtils.Color.average(faceColors);
      var avgReferenceColors = fc.colorUtils.Color.average(referenceColors);
      var hslDiff = {
        h: Math.abs(avgReferenceColors.toHsl()[0] - avgFaceColor.toHsl()[0]) * 0.4,
        s: Math.abs(avgReferenceColors.toHsl()[1] - avgFaceColor.toHsl()[1]) * 0.4,
        l: Math.abs(avgReferenceColors.toHsl()[2] - avgFaceColor.toHsl()[2]) * 0.4
      };
      return fc.utils.pleaseFilter('traceCountours', imgData, {
        cx: cx,
        cy: cy,
        iteration:100,
        referencepoints: points,
        references:referenceColors,
        stops: faceColors,
        hslDiff:hslDiff,
        rgbDiff:60
      });
    }).then(function(imgData){
      return fc.utils.pleaseFilter('removeContours',imgData,{
        cx: cx,
        cy: cy
      });
    }).then(function(imgData){
      return fc.utils.pleaseFilter('removeOutside',imgData,{
        cx: cx,
        cy: cy
      });
    }).then(function(imgData){
      return fc.utils.pleaseFilter('blendCountours',imgData,{
        cx: cx,
        cy: cy
      });
    }).then(function(imgData){
      return fc.utils.pleaseFilter('crop',imgData,{
        findBottom: 'right'
      });
    }).then(function (filteredData) {
      var canvas = this.$$('#' + PROCESSING);
      canvas.width = filteredData.width;
      canvas.height = filteredData.height;
      canvas.getContext('2d').putImageData(filteredData, 0, 0);
      fc.appState.foreground = filteredData;
      this.$$('footer').classList.remove('hidden');
      this.$$('.upper').classList.remove('hidden');

      // HACK resize canvas to force the browser to refresh [android chrome bug]
      canvas.classList.add('hidden');
      setTimeout(function () {
        canvas.classList.remove('hidden');
      }, 10);

      fc.ga('/still_awesome');
    }.bind(this)).catch(function () {
      fc.ga('/no_face');

      alert("Sorry, we didn't found your face. You should take another selfie.");
      page('/create');
    });
  };

}(FakeCation));
